jQuery(function ($) {
  function closeItem($acc, $item) {
    const $btn = $item.find('.accordion__header').first();
    const $panel = $item.find('.accordion__panel').first();

    $btn.attr('aria-expanded', 'false');
    $panel.prop('hidden', true).stop(true, true).slideUp(160, function () {
      $panel.css('display', '');
    });

    $item.removeClass('is-open');
  }

  function openItem($acc, $item) {
    const $btn = $item.find('.accordion__header').first();
    const $panel = $item.find('.accordion__panel').first();

    $btn.attr('aria-expanded', 'true');
    $panel.prop('hidden', false).hide().stop(true, true).slideDown(180, function () {
      $panel.css('display', '');
    });

    $item.addClass('is-open');
  }

  $(document).on('click', '.accordion[data-accordion="true"] .accordion__header', function () {
    const $btn = $(this);
    const $item = $btn.closest('.accordion__item');
    const $acc = $btn.closest('.accordion');
    const allowMultiple = ($acc.data('accordion-multiple') === 1 || $acc.data('accordion-multiple') === '1');

    const isOpen = ($btn.attr('aria-expanded') === 'true');

    if (!allowMultiple) {
      $acc.find('.accordion__item.is-open').each(function () {
        if (this !== $item[0]) closeItem($acc, $(this));
      });
    }

    if (isOpen) {
      closeItem($acc, $item);
    } else {
      openItem($acc, $item);
    }
  });

  // Optional: open from hash (#acc-xyz)
  function openFromHash() {
    const hash = window.location.hash;
    if (!hash) return;

    const $target = $(hash);
    if (!$target.length) return;

    const $item = $target.closest('.accordion__item');
    const $acc = $target.closest('.accordion[data-accordion="true"]');
    if (!$item.length || !$acc.length) return;

    openItem($acc, $item);
    const $btn = $item.find('.accordion__header').first();
    if ($btn.length) $btn[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  openFromHash();
});
